import { apiRoutes } from '@/app/apiConfig/apiRoutes';
import { Paged } from '../shared-components/Types/Paged';
import { Role } from '../shared-components/Types/Role';
import { apiSlice } from './apiSlice';

export const rolesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<Paged<Role>, void>({
      query: () => {
        return {
          url: `${apiRoutes.roles}`,
          method: 'GET',
        };
      },
      providesTags: ['Roles'],
    }),

    getRolesByRank: builder.query<Paged<Role>, void>({
      query: () => {
        return {
          url: `${apiRoutes.roles}?ranks=true`,
          method: 'GET',
        };
      },
      providesTags: ['RolesRank'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRolesQuery, useGetRolesByRankQuery } = rolesApiSlice;
